import type { EditorBlock } from '@/store/editorSlice';
import { isValidEmail, normalizeEmail } from './emailRule';

/**
 * Find the first valid email value entered into an `email` block on the
 * given screen's blocks. Used by QuizScreenWizard's lead-capture on Next.
 *
 * WEB-848: extracted from PublicQuiz.tsx (behavior-preserving move) so the
 * editor preview can render through the same wizard — mirrors the paywall
 * player's own `paywall-runtime/emailLookup.ts` (WEB-662 atom 1).
 *
 * WEB-1716: правило «это почта?» больше не живёт здесь своей копией регулярки —
 * оно одно на весь рантайм квиза (./emailRule) и то же самое читает гейт
 * экрана (requiredGate.findScreenBlockers). Иначе покупатель проходит гейт с
 * опечаткой, а лид по тому же значению молча не создаётся.
 */
export function findEmailValue(
  blocks: EditorBlock[],
  values: Record<string, string>,
): string | null {
  for (const block of blocks) {
    if (block.type !== 'email') continue;
    const v = normalizeEmail(values[block.id]);
    if (isValidEmail(v)) return v;
  }
  return null;
}
